<template>
  <div>
    <a-form-model-item v-if="env && !logoUi.hostname">
      <a-select v-model="sysDev" placeholder="选择系统" @change="sysChange">
        <a-select-option v-for="item in devSystem" :key="item.name" :value="item.appId">
          {{ item.name }}
        </a-select-option>
      </a-select>
    </a-form-model-item>
  </div>
</template>

<script>
import { getLogo } from '@/utils/intConfiguration';
import {
  rmToken,
  setUserSys,
} from '../login-handler';

const { system } = require('../../../../config/dev.proxy');

export default {
  name: 'Environment',

  data() {
    return {
      // eslint-disable-next-line global-require
      logoUi: getLogo(),
      sysDev: '',
      devSystem: system,
    };
  },
  computed: {
    env() {
      let env = false;
      try {
        env = process.env.NODE_ENV === 'development';
      } catch (e) {
        env = false;
      }
      return env;
    },
  },

  methods: {
    sysChange(value) {
      setUserSys(value);
      rmToken();
    },
  },
};
</script>
